import classNames from "classnames";

import { Typography } from "@braintrust/braintrust-ui-components";
import { useUser } from "@js/apps/common/hooks";
import type {
  OfferExtendedSystemMessage,
  UserSystemMessage,
} from "@js/types/messenger";

import { formatSentDate } from "../../utils";

import { SystemMessageCard } from "./system-message-card";

import styles from "./styles.module.scss";

export type SystemMessageToDisplayInSystemMessageComponent = Exclude<
  UserSystemMessage,
  OfferExtendedSystemMessage
>;

type SystemMessageProps = {
  systemMessage: SystemMessageToDisplayInSystemMessageComponent;
};

export const SystemMessageComponent = ({
  systemMessage,
}: SystemMessageProps) => {
  const user = useUser();
  if (!user) return null;

  const sentDate = formatSentDate(systemMessage.sent);
  const isActive = systemMessage.system_message_active;

  return (
    <div>
      <Typography
        component="p"
        size="small"
        color="grey-2"
        align="center"
        sx={{ mt: 4, mb: 1 }}
      >
        {sentDate}
      </Typography>
      <div
        className={classNames(styles.systemMessage, {
          [styles.systemMessageInactive]: !isActive,
        })}
      >
        <SystemMessageCard message={systemMessage} />
      </div>
    </div>
  );
};
